module.exports = __webpack_public_path__ + "img/experience.50a3c21d.png";